var Handlebars = require("../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var alias1=container.lambda, alias2=container.escapeExpression;

  return "<li class=\"FiveDaysWeaterList__item\" data-day=\""
    + alias2(alias1((depth0 != null ? depth0.dayForGala : depth0), depth0))
    + "\" data-weather=\""
    + alias2(alias1((depth0 != null ? depth0.weather : depth0), depth0))
    + "\">\r\n    <p class=\"FiveDaysWeaterList__item--day\" data-day=\""
    + alias2(alias1((depth0 != null ? depth0.dayForGala : depth0), depth0))
    + "\">"
    + alias2(alias1((depth0 != null ? depth0.day : depth0), depth0))
    + "</p>\r\n    <div class=\"FiveDaysWeaterList__item--date\" data-day=\""
    + alias2(alias1((depth0 != null ? depth0.dayForGala : depth0), depth0))
    + "\">"
    + alias2(alias1((depth0 != null ? depth0.date : depth0), depth0))
    + "</div>\r\n    <div data-day=\""
    + alias2(alias1((depth0 != null ? depth0.dayForGala : depth0), depth0))
    + "\">\r\n        <img class=\"FiveDaysWeaterList__item--icon\" src=\"https://openweathermap.org/img/w/"
    + alias2(alias1((depth0 != null ? depth0.icon : depth0), depth0))
    + ".png\"\r\n            alt=\"weather-ico\" data-day=\""
    + alias2(alias1((depth0 != null ? depth0.dayForGala : depth0), depth0))
    + "\"/>\r\n    </div>\r\n    <div class=\"FiveDaysWeaterList__item--min-max-label\" data-day=\""
    + alias2(alias1((depth0 != null ? depth0.dayForGala : depth0), depth0))
    + "\">\r\n        <span data-day=\""
    + alias2(alias1((depth0 != null ? depth0.dayForGala : depth0), depth0))
    + "\">min</span><span data-day=\""
    + alias2(alias1((depth0 != null ? depth0.dayForGala : depth0), depth0))
    + "\">max</span>\r\n    </div>\r\n    <div class=\"FiveDaysWeaterList__item--min-max\" data-day=\""
    + alias2(alias1((depth0 != null ? depth0.dayForGala : depth0), depth0))
    + "\">\r\n        <span data-day=\""
    + alias2(alias1((depth0 != null ? depth0.dayForGala : depth0), depth0))
    + "\">"
    + alias2(alias1((depth0 != null ? depth0.min : depth0), depth0))
    + " &deg;</span>\r\n        <span data-day=\""
    + alias2(alias1((depth0 != null ? depth0.dayForGala : depth0), depth0))
    + "\">"
    + alias2(alias1((depth0 != null ? depth0.max : depth0), depth0))
    + " &deg;</span>\r\n    </div>\r\n    <button class=\"FiveDaysWeaterList__item--moreBtn\" data-day=\""
    + alias2(alias1((depth0 != null ? depth0.dayForGala : depth0), depth0))
    + "\">\r\n        more info\r\n    </button>\r\n</li>\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),depth0,{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":20,"column":9}}})) != null ? stack1 : "");
},"useData":true});